import { Button, Col, Row } from 'antd';
import { SubmitButton } from 'formik-antd';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { Debug } from './Debug';

const StyledSubmitButton = styled(SubmitButton)`
	width: 100%;
	height: 40px;
	font-weight: 600;
	font-size: 10px;
	border: 0;
	background-color: ${(props) => props.theme.colors.Capri};
	color: ${(props) => props.theme.colors.IndigoDye};
	&:hover {
		background-color: ${(props) => props.theme.colors.Capri};
		color: ${(props) => props.theme.colors.IndigoDye};
	}
`;

function FormActionButtons({
	isSubmitting,
	isValid = true,
	resetForm = null,
	showCancel = true,
	buttonAlignment = 'center',
	showDebug = true,
	saveText = 'Save',
	cancelText = 'Cancel',
}) {
	return (
		<>
			<Row data-testid="FormActionButtons" type="flex" justify="space-between">
				<Col
					span={24}
					style={{
						textAlign: buttonAlignment,
					}}
				>
					{showCancel && (
						<Button
							className="custom-btn"
							onClick={resetForm}
							style={{
								marginRight: 20,
							}}
						>
							{cancelText}
						</Button>
					)}
					<StyledSubmitButton
						// type="primary"
						id="form-submit"
						disabled={isSubmitting || !isValid}
					>
						{saveText}
					</StyledSubmitButton>
				</Col>
			</Row>
			{process.env.NODE_ENV === 'development' && showDebug && <Debug />}
		</>
	);
}

FormActionButtons.propTypes = {
	isSubmitting: PropTypes.bool.isRequired,
	isValid: PropTypes.bool,
	showCancel: PropTypes.bool,
	showDebug: PropTypes.bool,
	buttonAlignment: PropTypes.string,
	saveText: PropTypes.string,
	cancelText: PropTypes.string,
	resetForm: PropTypes.func,
};

export { FormActionButtons };
